export type MessageAttachmentType = 'imagen' | 'audio' | 'sticker' | 'gif';

export type ConversationType = 'oyente-oyente' | 'oyente-locutor' | 'oyente-moderador' | 'locutor-locutor';

export interface MessageAttachment {
  type: MessageAttachmentType;
  url: string;
  name?: string;
  duration?: string;
  size?: string;
  width?: number;
  height?: number;
}

export interface PrivateMessage {
  id: string;
  conversationId: string;
  senderId: string;
  senderName: string;
  senderPhoto: string;
  text: string;
  timestamp: string;
  timestampRelative: string;
  isRead: boolean;
  isDeleted: boolean;
  isReported: boolean;
  attachment?: MessageAttachment;
}

export interface ConversationParticipant {
  id: string;
  name: string;
  username: string;
  photoUrl: string;
  type: 'oyente' | 'locutor' | 'moderador';
  isOnline: boolean;
  isTyping: boolean;
  isBlocked: boolean;
  lastSeen: string;
}

export interface PrivateConversation {
  id: string;
  type: ConversationType;
  participants: ConversationParticipant[];
  lastMessage: string;
  lastMessageTime: string;
  lastMessageRelative: string;
  unreadCount: number;
  isPinned: boolean;
  isArchived: boolean;
  messages: PrivateMessage[];
}

export interface BlockedUser {
  id: string;
  name: string;
  username: string;
  photoUrl: string;
  type: string;
  blockedDate: string;
  reason: string;
}

export interface PrivateMessagesDashboardStats {
  totalConversations: number;
  totalMessages: number;
  unreadMessages: number;
  activeContacts: number;
  blockedUsers: number;
  dailyAvgMessages: number;
  imagesShared: number;
  audioSent: number;
}

export const privateMessagesDashboardStats: PrivateMessagesDashboardStats = {
  totalConversations: 347200,
  totalMessages: 4830000,
  unreadMessages: 18900,
  activeContacts: 56200,
  blockedUsers: 12400,
  dailyAvgMessages: 127,
  imagesShared: 89200,
  audioSent: 34100,
};

export const blockedUsersList: BlockedUser[] = [
  {
    id: 'blocked-1',
    name: 'Usuario Tóxico 2847',
    username: '@toxicol_2847',
    photoUrl: 'https://readdy.ai/api/search-image?query=Generic%20anonymous%20user%20avatar%20dark%20silhouette%20neutral%20gray%20background%20minimal%20identity%20placeholder%20simple%20flat%20design&width=200&height=200&seq=pm-blocked-01&orientation=squarish',
    type: 'Oyente',
    blockedDate: '2026-06-18',
    reason: 'Spam repetitivo en mensajes',
  },
  {
    id: 'blocked-2',
    name: 'Troll FM 99',
    username: '@troll_fm99',
    photoUrl: 'https://readdy.ai/api/search-image?query=Anonymous%20generic%20user%20profile%20silhouette%20dark%20gray%20circular%20avatar%20minimalistic%20icon%20style%20placeholder%20no%20identity&width=200&height=200&seq=pm-blocked-02&orientation=squarish',
    type: 'Oyente',
    blockedDate: '2026-06-15',
    reason: 'Comportamiento inapropiado',
  },
  {
    id: 'blocked-3',
    name: 'SpamBot Radio',
    username: '@spambot_radio',
    photoUrl: 'https://readdy.ai/api/search-image?query=Bot%20like%20generic%20avatar%20silhouette%20minimalist%20gray%20circle%20neutral%20background%20simple%20icon%20placeholder&width=200&height=200&seq=pm-blocked-03&orientation=squarish',
    type: 'Oyente',
    blockedDate: '2026-06-10',
    reason: 'Cuenta automatizada detectada',
  },
  {
    id: 'blocked-4',
    name: 'Hater Anónimo',
    username: '@hater_anon',
    photoUrl: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20silhouette%20avatar%20plain%20background%20minimal%20generic%20user%20profile%20icon%20simple%20clean%20design&width=200&height=200&seq=pm-blocked-04&orientation=squarish',
    type: 'Oyente',
    blockedDate: '2026-06-05',
    reason: 'Mensajes ofensivos',
  },
  {
    id: 'blocked-5',
    name: 'PromoMolesto 777',
    username: '@promo_777',
    photoUrl: 'https://readdy.ai/api/search-image?query=Plain%20generic%20user%20avatar%20silhouette%20flat%20neutral%20gray%20circular%20icon%20minimal%20anonymous%20profile%20placeholder&width=200&height=200&seq=pm-blocked-05&orientation=squarish',
    type: 'Oyente',
    blockedDate: '2026-05-28',
    reason: 'Autopromoción no solicitada',
  },
];

export const privateConversations: PrivateConversation[] = [
  // ═══════ CONVERSACIÓN 1: Oyente ↔ Locutor ═══════
  {
    id: 'conv-1',
    type: 'oyente-locutor',
    participants: [
      {
        id: 'pm-user-marco',
        name: 'Marco Antonio Rivera',
        username: '@marco_oyente',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20confident%20Latino%20male%20portrait%20warm%20genuine%20friendly%20smile%20casual%20olive%20green%20henley%20shirt%20soft%20warm%20cream%20background%20natural%20lighting%20approachable%20authentic%20headshot&width=200&height=200&seq=pm-marco&orientation=squarish',
        type: 'oyente',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
      {
        id: 'pm-user-vale',
        name: 'Valentina Ríos',
        username: '@vale_radio',
        photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20radio%20host%20portrait%20confident%20warm%20smile%20studio%20with%20microphones%20golden%20hour%20lighting%20clean%20editorial%20photography%20charismatic&width=200&height=200&seq=pm-vale&orientation=squarish',
        type: 'locutor',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'En cabina',
      },
    ],
    lastMessage: '¡Gracias Marco! Me alegra que te haya gustado el programa de hoy. Mañana tenemos una sorpresa... 🤫',
    lastMessageTime: '2026-06-21T09:45:00Z',
    lastMessageRelative: 'Hace 5 min',
    unreadCount: 1,
    isPinned: true,
    isArchived: false,
    messages: [
      {
        id: 'msg-1-1',
        conversationId: 'conv-1',
        senderId: 'pm-user-marco',
        senderName: 'Marco Antonio Rivera',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20confident%20Latino%20male%20portrait%20warm%20genuine%20friendly%20smile%20casual%20olive%20green%20henley%20shirt%20soft%20warm%20cream%20background%20natural%20lighting%20approachable%20authentic%20headshot&width=80&height=80&seq=pm-msg-1-1&orientation=squarish',
        text: '¡Hola Vale! Quería decirte que el programa de hoy estuvo INCREÍBLE. La entrevista con el invitado sorpresa me dejó sin palabras.',
        timestamp: '2026-06-21T09:30:00Z',
        timestampRelative: 'Hace 20 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-1-2',
        conversationId: 'conv-1',
        senderId: 'pm-user-vale',
        senderName: 'Valentina Ríos',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20radio%20host%20portrait%20confident%20warm%20smile%20studio%20with%20microphones%20golden%20hour%20lighting%20clean%20editorial%20photography%20charismatic&width=80&height=80&seq=pm-msg-1-2&orientation=squarish',
        text: '¡Ay Marco! Mil gracias de verdad 🥹 Me encanta saber que lo disfrutaste. La producción estuvo intensa pero valió cada minuto.',
        timestamp: '2026-06-21T09:33:00Z',
        timestampRelative: 'Hace 17 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-1-3',
        conversationId: 'conv-1',
        senderId: 'pm-user-marco',
        senderName: 'Marco Antonio Rivera',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20confident%20Latino%20male%20portrait%20warm%20genuine%20friendly%20smile%20casual%20olive%20green%20henley%20shirt%20soft%20warm%20cream%20background%20natural%20lighting%20approachable%20authentic%20headshot&width=80&height=80&seq=pm-msg-1-3&orientation=squarish',
        text: 'Se nota el cariño que le ponen. Te mando una foto que saqué del estudio improvisado que armé para escucharte mejor jaja',
        timestamp: '2026-06-21T09:35:00Z',
        timestampRelative: 'Hace 15 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'imagen',
          url: 'https://readdy.ai/api/search-image?query=Cozy%20home%20listening%20setup%20with%20vintage%20radio%20receiver%20warm%20ambient%20lighting%20comfortable%20chair%20coffee%20mug%20headphones%20neatly%20arranged%20creative%20personal%20listening%20space%20editorial%20photography%20warm%20tones&width=800&height=600&seq=pm-att-img-1&orientation=landscape',
          name: 'mi_estudio_radio.jpg',
          size: '2.4 MB',
          width: 800,
          height: 600,
        },
      },
      {
        id: 'msg-1-4',
        conversationId: 'conv-1',
        senderId: 'pm-user-vale',
        senderName: 'Valentina Ríos',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20radio%20host%20portrait%20confident%20warm%20smile%20studio%20with%20microphones%20golden%20hour%20lighting%20clean%20editorial%20photography%20charismatic&width=80&height=80&seq=pm-msg-1-4&orientation=squarish',
        text: '¡NO PUEDO CREERLO! ¡Qué genial! 😍 Ese setup está espectacular. Lo voy a mostrar en el programa de mañana si me das permiso.',
        timestamp: '2026-06-21T09:38:00Z',
        timestampRelative: 'Hace 12 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-1-5',
        conversationId: 'conv-1',
        senderId: 'pm-user-marco',
        senderName: 'Marco Antonio Rivera',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20confident%20Latino%20male%20portrait%20warm%20genuine%20friendly%20smile%20casual%20olive%20green%20henley%20shirt%20soft%20warm%20cream%20background%20natural%20lighting%20approachable%20authentic%20headshot&width=80&height=80&seq=pm-msg-1-5&orientation=squarish',
        text: '¡Claro que sí! Sería un honor. También grabé un audio de cuando entró la cortina del programa, por si te sirve para algo.',
        timestamp: '2026-06-21T09:40:00Z',
        timestampRelative: 'Hace 10 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'audio',
          url: '',
          name: 'cortina_tardes_con_vale.mp3',
          duration: '0:34',
          size: '1.2 MB',
        },
      },
      {
        id: 'msg-1-6',
        conversationId: 'conv-1',
        senderId: 'pm-user-vale',
        senderName: 'Valentina Ríos',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20radio%20host%20portrait%20confident%20warm%20smile%20studio%20with%20microphones%20golden%20hour%20lighting%20clean%20editorial%20photography%20charismatic&width=80&height=80&seq=pm-msg-1-6&orientation=squarish',
        text: '¡Gracias Marco! Me alegra que te haya gustado el programa de hoy. Mañana tenemos una sorpresa... 🤫',
        timestamp: '2026-06-21T09:45:00Z',
        timestampRelative: 'Hace 5 min',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 2: Oyente ↔ Oyente ═══════
  {
    id: 'conv-2',
    type: 'oyente-oyente',
    participants: [
      {
        id: 'pm-user-sofia',
        name: 'Sofía Hernández',
        username: '@sofia_oyente',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20portrait%20friendly%20warm%20smile%20casual%20modern%20style%20soft%20warm%20neutral%20background%20editorial%20headshot%20clean%20professional%20photography&width=200&height=200&seq=pm-sofia&orientation=squarish',
        type: 'oyente',
        isOnline: true,
        isTyping: true,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
      {
        id: 'pm-user-carlos',
        name: 'Carlos Mendoza',
        username: '@carlos_fan',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20mid%20twenties%20casual%20style%20warm%20smile%20premium%20portrait%20photography%20soft%20neutral%20background%20editorial%20quality%20headshot%20approachable&width=200&height=200&seq=pm-carlos-m&orientation=squarish',
        type: 'oyente',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
    ],
    lastMessage: 'Estoy grabando el partido para verlo después. No me spoileen que lo veo a la noche 😂',
    lastMessageTime: '2026-06-21T09:42:00Z',
    lastMessageRelative: 'Hace 8 min',
    unreadCount: 2,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-2-1',
        conversationId: 'conv-2',
        senderId: 'pm-user-carlos',
        senderName: 'Carlos Mendoza',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20mid%20twenties%20casual%20style%20warm%20smile%20premium%20portrait%20photography%20soft%20neutral%20background%20editorial%20quality%20headshot%20approachable&width=80&height=80&seq=pm-msg-2-1&orientation=squarish',
        text: '¡Sofi! ¿Viste lo que pasó en el partido anoche? ¡Qué locura! ⚽🔥',
        timestamp: '2026-06-21T09:20:00Z',
        timestampRelative: 'Hace 30 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-2-2',
        conversationId: 'conv-2',
        senderId: 'pm-user-sofia',
        senderName: 'Sofía Hernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20portrait%20friendly%20warm%20smile%20casual%20modern%20style%20soft%20warm%20neutral%20background%20editorial%20headshot%20clean%20professional%20photography&width=80&height=80&seq=pm-msg-2-2&orientation=squarish',
        text: '¡NO ME DIGAS NADA! Todavía no lo vi 😭 Lo tengo grabado. Pero contame, ¿ganaron?',
        timestamp: '2026-06-21T09:22:00Z',
        timestampRelative: 'Hace 28 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-2-3',
        conversationId: 'conv-2',
        senderId: 'pm-user-carlos',
        senderName: 'Carlos Mendoza',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20mid%20twenties%20casual%20style%20warm%20smile%20premium%20portrait%20photography%20soft%20neutral%20background%20editorial%20quality%20headshot%20approachable&width=80&height=80&seq=pm-msg-2-3&orientation=squarish',
        text: 'Jajaja bueno, no te digo nada entonces. Pero te mando este sticker que resume mi reacción.',
        timestamp: '2026-06-21T09:25:00Z',
        timestampRelative: 'Hace 25 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'sticker',
          url: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20soccer%20ball%20character%20celebrating%20with%20confetti%20and%20fireworks%20joyful%20expression%20vibrant%20colors%20fun%20playful%20sticker%20style%20illustration%20on%20transparent%20background&width=400&height=400&seq=pm-sticker-1&orientation=squarish',
          name: 'celebracion_futbol.webp',
        },
      },
      {
        id: 'msg-2-4',
        conversationId: 'conv-2',
        senderId: 'pm-user-sofia',
        senderName: 'Sofía Hernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20portrait%20friendly%20warm%20smile%20casual%20modern%20style%20soft%20warm%20neutral%20background%20editorial%20headshot%20clean%20professional%20photography&width=80&height=80&seq=pm-msg-2-4&orientation=squarish',
        text: 'JAJAJA ese sticker es genial. ¿De dónde lo sacaste?',
        timestamp: '2026-06-21T09:28:00Z',
        timestampRelative: 'Hace 22 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-2-5',
        conversationId: 'conv-2',
        senderId: 'pm-user-carlos',
        senderName: 'Carlos Mendoza',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20mid%20twenties%20casual%20style%20warm%20smile%20premium%20portrait%20photography%20soft%20neutral%20background%20editorial%20quality%20headshot%20approachable&width=80&height=80&seq=pm-msg-2-5&orientation=squarish',
        text: 'Del pack de stickers de RFW Deportes. Son buenísimos. Te paso este que es mi favorito.',
        timestamp: '2026-06-21T09:30:00Z',
        timestampRelative: 'Hace 20 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'gif',
          url: 'https://readdy.ai/api/search-image?query=Funny%20animated%20style%20soccer%20fan%20celebrating%20jumping%20up%20and%20down%20with%20excitement%20colorful%20confetti%20explosion%20happy%20dancing%20character%20loop%20animation%20vibrant%20energetic&width=400&height=400&seq=pm-gif-1&orientation=squarish',
          name: 'fan_celebrando.gif',
          size: '890 KB',
        },
      },
      {
        id: 'msg-2-6',
        conversationId: 'conv-2',
        senderId: 'pm-user-sofia',
        senderName: 'Sofía Hernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20portrait%20friendly%20warm%20smile%20casual%20modern%20style%20soft%20warm%20neutral%20background%20editorial%20headshot%20clean%20professional%20photography&width=80&height=80&seq=pm-msg-2-6&orientation=squarish',
        text: 'Me muerooo 🤣🤣🤣 Es perfecto. Bueno, no me digas nada más del partido. ¿Vas a escuchar Carrusel Deportivo hoy?',
        timestamp: '2026-06-21T09:35:00Z',
        timestampRelative: 'Hace 15 min',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-2-7',
        conversationId: 'conv-2',
        senderId: 'pm-user-carlos',
        senderName: 'Carlos Mendoza',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20mid%20twenties%20casual%20style%20warm%20smile%20premium%20portrait%20photography%20soft%20neutral%20background%20editorial%20quality%20headshot%20approachable&width=80&height=80&seq=pm-msg-2-7&orientation=squarish',
        text: 'Obvio que sí. Estoy grabando el partido para verlo después. No me spoileen que lo veo a la noche 😂',
        timestamp: '2026-06-21T09:42:00Z',
        timestampRelative: 'Hace 8 min',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 3: Oyente ↔ Moderador ═══════
  {
    id: 'conv-3',
    type: 'oyente-moderador',
    participants: [
      {
        id: 'pm-user-lucia',
        name: 'Lucía Fernández',
        username: '@lucia_radiofan',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20curly%20dark%20hair%20warm%20genuine%20smile%20artistic%20bohemian%20style%20soft%20golden%20hour%20lighting%20editorial%20portrait%20gentle%20natural%20authentic&width=200&height=200&seq=pm-lucia&orientation=squarish',
        type: 'oyente',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 1 hora',
      },
      {
        id: 'pm-user-fernanda',
        name: 'Fernanda Castro',
        username: '@fernanda_mod',
        photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20late%20twenties%20friendly%20but%20authoritative%20style%20clean%20studio%20portrait%20warm%20but%20professional%20lighting%20editorial%20photography&width=200&height=200&seq=pm-fernanda&orientation=squarish',
        type: 'moderador',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
    ],
    lastMessage: '¡Perfecto! Cualquier cosa que necesites, ya sabés que podés escribirme. La comunidad es de todos. 😊',
    lastMessageTime: '2026-06-20T22:30:00Z',
    lastMessageRelative: 'Ayer',
    unreadCount: 0,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-3-1',
        conversationId: 'conv-3',
        senderId: 'pm-user-lucia',
        senderName: 'Lucía Fernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20curly%20dark%20hair%20warm%20genuine%20smile%20artistic%20bohemian%20style%20soft%20golden%20hour%20lighting%20editorial%20portrait%20gentle%20natural%20authentic&width=80&height=80&seq=pm-msg-3-1&orientation=squarish',
        text: 'Hola Fer, quería consultarte algo. Noté que en el chat de Onda Nocturna hay un usuario que está spameando links raros. ¿Eso se reporta por acá?',
        timestamp: '2026-06-20T22:00:00Z',
        timestampRelative: 'Ayer 22:00',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-3-2',
        conversationId: 'conv-3',
        senderId: 'pm-user-fernanda',
        senderName: 'Fernanda Castro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20late%20twenties%20friendly%20but%20authoritative%20style%20clean%20studio%20portrait%20warm%20but%20professional%20lighting%20editorial%20photography&width=80&height=80&seq=pm-msg-3-2&orientation=squarish',
        text: '¡Hola Lucía! Gracias por avisar. Sí, podés usar el botón de reportar en el chat de la cabina o mandarme el @username por acá y lo reviso en el momento.',
        timestamp: '2026-06-20T22:05:00Z',
        timestampRelative: 'Ayer 22:05',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-3-3',
        conversationId: 'conv-3',
        senderId: 'pm-user-lucia',
        senderName: 'Lucía Fernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20curly%20dark%20hair%20warm%20genuine%20smile%20artistic%20bohemian%20style%20soft%20golden%20hour%20lighting%20editorial%20portrait%20gentle%20natural%20authentic&width=80&height=80&seq=pm-msg-3-3&orientation=squarish',
        text: 'Es @spamlink_99. Estuvo mandando como 5 links en 2 minutos. También te mando captura por si sirve.',
        timestamp: '2026-06-20T22:10:00Z',
        timestampRelative: 'Ayer 22:10',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'imagen',
          url: 'https://readdy.ai/api/search-image?query=Screenshot%20of%20a%20chat%20interface%20showing%20multiple%20spam%20messages%20with%20suspicious%20links%20clean%20UI%20mockup%20moderation%20context%20professional%20screenshot%20style%20clear%20readable&width=800&height=500&seq=pm-att-img-2&orientation=landscape',
          name: 'captura_spam.png',
          size: '1.8 MB',
          width: 800,
          height: 500,
        },
      },
      {
        id: 'msg-3-4',
        conversationId: 'conv-3',
        senderId: 'pm-user-fernanda',
        senderName: 'Fernanda Castro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20late%20twenties%20friendly%20but%20authoritative%20style%20clean%20studio%20portrait%20warm%20but%20professional%20lighting%20editorial%20photography&width=80&height=80&seq=pm-msg-3-4&orientation=squarish',
        text: '¡Excelente! Ya lo tengo. Le apliqué silencio permanente y limpié los mensajes. Gracias por estar atenta, así mantenemos la comunidad sana. 💪',
        timestamp: '2026-06-20T22:15:00Z',
        timestampRelative: 'Ayer 22:15',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-3-5',
        conversationId: 'conv-3',
        senderId: 'pm-user-lucia',
        senderName: 'Lucía Fernández',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20curly%20dark%20hair%20warm%20genuine%20smile%20artistic%20bohemian%20style%20soft%20golden%20hour%20lighting%20editorial%20portrait%20gentle%20natural%20authentic&width=80&height=80&seq=pm-msg-3-5&orientation=squarish',
        text: '¡Gracias Fer! Sos lo más. Me encanta que la moderación sea tan rápida. Da gusto ser parte de esta comunidad.',
        timestamp: '2026-06-20T22:20:00Z',
        timestampRelative: 'Ayer 22:20',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-3-6',
        conversationId: 'conv-3',
        senderId: 'pm-user-fernanda',
        senderName: 'Fernanda Castro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20late%20twenties%20friendly%20but%20authoritative%20style%20clean%20studio%20portrait%20warm%20but%20professional%20lighting%20editorial%20photography&width=80&height=80&seq=pm-msg-3-6&orientation=squarish',
        text: '¡Perfecto! Cualquier cosa que necesites, ya sabés que podés escribirme. La comunidad es de todos. 😊',
        timestamp: '2026-06-20T22:30:00Z',
        timestampRelative: 'Ayer 22:30',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 4: Locutor ↔ Locutor ═══════
  {
    id: 'conv-4',
    type: 'locutor-locutor',
    participants: [
      {
        id: 'pm-user-ricky',
        name: 'Ricky Navarro',
        username: '@ricky_navarro',
        photoUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20radio%20host%20portrait%20warm%20smile%20professional%20studio%20setting%20golden%20lighting%20clean%20background%20editorial%20photography%20friendly&width=200&height=200&seq=pm-ricky&orientation=squarish',
        type: 'locutor',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'En cabina',
      },
      {
        id: 'pm-user-dieguito',
        name: 'Diego Montenegro',
        username: '@dieguito_rock',
        photoUrl: 'https://readdy.ai/api/search-image?query=Latino%20comedian%20radio%20host%20portrait%20humorous%20expression%20casual%20relaxed%20studio%20vibe%20warm%20atmospheric%20lighting%20authentic%20personality%20rock%20style&width=200&height=200&seq=pm-dieguito&orientation=squarish',
        type: 'locutor',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 5 horas',
      },
    ],
    lastMessage: 'Dale, lo armamos. El viernes que viene cross-over matutino/nocturno. ¡La gente va a enloquecer! 🔥',
    lastMessageTime: '2026-06-20T23:00:00Z',
    lastMessageRelative: 'Ayer',
    unreadCount: 0,
    isPinned: true,
    isArchived: false,
    messages: [
      {
        id: 'msg-4-1',
        conversationId: 'conv-4',
        senderId: 'pm-user-ricky',
        senderName: 'Ricky Navarro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20radio%20host%20portrait%20warm%20smile%20professional%20studio%20setting%20golden%20lighting%20clean%20background%20editorial%20photography%20friendly&width=80&height=80&seq=pm-msg-4-1&orientation=squarish',
        text: '¡Diego! Che, ¿viste los números del ranking de esta semana? Los dos estamos en el top 5 de locutores. ¡Hay que celebrarlo!',
        timestamp: '2026-06-20T22:00:00Z',
        timestampRelative: 'Ayer 22:00',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-4-2',
        conversationId: 'conv-4',
        senderId: 'pm-user-dieguito',
        senderName: 'Diego Montenegro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20comedian%20radio%20host%20portrait%20humorous%20expression%20casual%20relaxed%20studio%20vibe%20warm%20atmospheric%20lighting%20authentic%20personality%20rock%20style&width=80&height=80&seq=pm-msg-4-2&orientation=squarish',
        text: '¡Nooo! ¿En serio? No lo había visto, estuve todo el día preparando el especial de rock argentino para mañana. ¡Qué locura hermano! 🎸',
        timestamp: '2026-06-20T22:30:00Z',
        timestampRelative: 'Ayer 22:30',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-4-3',
        conversationId: 'conv-4',
        senderId: 'pm-user-ricky',
        senderName: 'Ricky Navarro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20radio%20host%20portrait%20warm%20smile%20professional%20studio%20setting%20golden%20lighting%20clean%20background%20editorial%20photography%20friendly&width=80&height=80&seq=pm-msg-4-3&orientation=squarish',
        text: 'Sí, estamos rompiéndola. Estaba pensando... ¿y si hacemos un cross-over? Yo arranco en la mañana, vos cerrás la noche, y en el medio hacemos un bloque en conjunto. Algo tipo Banda & Rock.',
        timestamp: '2026-06-20T22:45:00Z',
        timestampRelative: 'Ayer 22:45',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-4-4',
        conversationId: 'conv-4',
        senderId: 'pm-user-dieguito',
        senderName: 'Diego Montenegro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20comedian%20radio%20host%20portrait%20humorous%20expression%20casual%20relaxed%20studio%20vibe%20warm%20atmospheric%20lighting%20authentic%20personality%20rock%20style&width=80&height=80&seq=pm-msg-4-4&orientation=squarish',
        text: '¡ME ENCANTA LA IDEA! Banda & Rock suena espectacular. Tengo unos invitados que podrían sumarse. Te mando una nota de voz con lo que estoy pensando.',
        timestamp: '2026-06-20T22:50:00Z',
        timestampRelative: 'Ayer 22:50',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'audio',
          url: '',
          name: 'idea_crossover.m4a',
          duration: '1:42',
          size: '3.1 MB',
        },
      },
      {
        id: 'msg-4-5',
        conversationId: 'conv-4',
        senderId: 'pm-user-ricky',
        senderName: 'Ricky Navarro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20radio%20host%20portrait%20warm%20smile%20professional%20studio%20setting%20golden%20lighting%20clean%20background%20editorial%20photography%20friendly&width=80&height=80&seq=pm-msg-4-5&orientation=squarish',
        text: 'Escuché el audio. ¡ESTO ES ORO PURO! 🤘 La lista de invitados que tiraste es brutal. Ya hablé con producción y me dieron luz verde. ¿Viernes que viene?',
        timestamp: '2026-06-20T22:55:00Z',
        timestampRelative: 'Ayer 22:55',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-4-6',
        conversationId: 'conv-4',
        senderId: 'pm-user-dieguito',
        senderName: 'Diego Montenegro',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20comedian%20radio%20host%20portrait%20humorous%20expression%20casual%20relaxed%20studio%20vibe%20warm%20atmospheric%20lighting%20authentic%20personality%20rock%20style&width=80&height=80&seq=pm-msg-4-6&orientation=squarish',
        text: 'Dale, lo armamos. El viernes que viene cross-over matutino/nocturno. ¡La gente va a enloquecer! 🔥',
        timestamp: '2026-06-20T23:00:00Z',
        timestampRelative: 'Ayer 23:00',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 5: Oyente ↔ Oyente (nueva) ═══════
  {
    id: 'conv-5',
    type: 'oyente-oyente',
    participants: [
      {
        id: 'pm-user-javier',
        name: 'Javier El Loco Ramírez',
        username: '@elloco_javier',
        photoUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=200&height=200&seq=pm-javier&orientation=squarish',
        type: 'oyente',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
      {
        id: 'pm-user-diego-m',
        name: 'Diego Martínez',
        username: '@dieguito_rfw',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20early%20twenties%20trendy%20streetwear%20style%20confident%20expression%20urban%20background%20portrait%20photography%20casual%20cool%20modern&width=200&height=200&seq=pm-diego-mtz&orientation=squarish',
        type: 'oyente',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 30 min',
      },
    ],
    lastMessage: 'Estoy desde las 5 AM despierto para no perderme el anuncio. ¡Qué emoción!',
    lastMessageTime: '2026-06-21T08:00:00Z',
    lastMessageRelative: 'Hace 2 horas',
    unreadCount: 4,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-5-1',
        conversationId: 'conv-5',
        senderId: 'pm-user-javier',
        senderName: 'Javier El Loco Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=80&height=80&seq=pm-msg-5-1&orientation=squarish',
        text: '¡DIEGUITOOOO! ¿Ya viste que La Kalle anunció el concurso del año? ¡Hay que participar sí o sí! 🏆',
        timestamp: '2026-06-21T07:30:00Z',
        timestampRelative: 'Hace 2.5 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-5-2',
        conversationId: 'conv-5',
        senderId: 'pm-user-diego-m',
        senderName: 'Diego Martínez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20early%20twenties%20trendy%20streetwear%20style%20confident%20expression%20urban%20background%20portrait%20photography%20casual%20cool%20modern&width=80&height=80&seq=pm-msg-5-2&orientation=squarish',
        text: '¿CUÁL CONCURSO? No vi nada! Contame ya!',
        timestamp: '2026-06-21T07:35:00Z',
        timestampRelative: 'Hace 2.5 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-5-3',
        conversationId: 'conv-5',
        senderId: 'pm-user-javier',
        senderName: 'Javier El Loco Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=80&height=80&seq=pm-msg-5-3&orientation=squarish',
        text: 'El "Rey de la Sintonía 2026". Premio mayor: un viaje a Medellín con todo pago para ver el RFW Fest EN VIVO. Hay que adivinar 10 canciones en 30 segundos.',
        timestamp: '2026-06-21T07:38:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-5-4',
        conversationId: 'conv-5',
        senderId: 'pm-user-diego-m',
        senderName: 'Diego Martínez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20early%20twenties%20trendy%20streetwear%20style%20confident%20expression%20urban%20background%20portrait%20photography%20casual%20cool%20modern&width=80&height=80&seq=pm-msg-5-4&orientation=squarish',
        text: 'NOOOOO que locura. Yo me sé todas las canciones de La Kalle de memoria. ¡A entrenar se ha dicho! 💪',
        timestamp: '2026-06-21T07:45:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'sticker',
          url: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20character%20wearing%20headphones%20dancing%20excitedly%20with%20music%20notes%20floating%20around%20vibrant%20neon%20colors%20fun%20sticker%20style%20energetic%20illustration%20on%20transparent%20background&width=400&height=400&seq=pm-sticker-2&orientation=squarish',
          name: 'modo_entrenamiento.webp',
        },
      },
      {
        id: 'msg-5-5',
        conversationId: 'conv-5',
        senderId: 'pm-user-javier',
        senderName: 'Javier El Loco Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=80&height=80&seq=pm-msg-5-5&orientation=squarish',
        text: 'Ese es mi Dieguito. Las inscripciones abren mañana a las 10 AM. ¡No lleguemos tarde que seguro se llena!',
        timestamp: '2026-06-21T07:55:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-5-6',
        conversationId: 'conv-5',
        senderId: 'pm-user-diego-m',
        senderName: 'Diego Martínez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20early%20twenties%20trendy%20streetwear%20style%20confident%20expression%20urban%20background%20portrait%20photography%20casual%20cool%20modern&width=80&height=80&seq=pm-msg-5-6&orientation=squarish',
        text: 'Pongo alarma YA. ¿Vos ya te inscribiste?',
        timestamp: '2026-06-21T07:58:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-5-7',
        conversationId: 'conv-5',
        senderId: 'pm-user-javier',
        senderName: 'Javier El Loco Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=80&height=80&seq=pm-msg-5-7&orientation=squarish',
        text: 'Todavía no, abre mañana. Pero ya tengo todo listo. Practiqué con el juego de prueba que publicaron.',
        timestamp: '2026-06-21T08:00:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: false,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'gif',
          url: 'https://readdy.ai/api/search-image?query=Excited%20animated%20character%20counting%20down%20with%20fingers%20five%20four%20three%20two%20one%20anticipation%20building%20colorful%20vibrant%20loop%20animation%20fun%20energetic&width=400&height=400&seq=pm-gif-2&orientation=squarish',
          name: 'cuenta_regresiva.gif',
          size: '1.4 MB',
        },
      },
      {
        id: 'msg-5-8',
        conversationId: 'conv-5',
        senderId: 'pm-user-javier',
        senderName: 'Javier El Loco Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Charismatic%20Latino%20man%20mid%20thirties%20fun%20energetic%20personality%20colorful%20shirt%20warm%20genuine%20laugh%20outdoor%20portrait%20natural%20daylight%20vibrant&width=80&height=80&seq=pm-msg-5-8&orientation=squarish',
        text: 'Estoy desde las 5 AM despierto para no perderme el anuncio. ¡Qué emoción!',
        timestamp: '2026-06-21T08:00:00Z',
        timestampRelative: 'Hace 2 horas',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 6: Oyente ↔ Locutor ═══════
  {
    id: 'conv-6',
    type: 'oyente-locutor',
    participants: [
      {
        id: 'pm-user-alejandro',
        name: 'Alejandro Ramírez',
        username: '@ale_locutor',
        photoUrl: 'https://readdy.ai/api/search-image?query=Mature%20distinguished%20Latino%20radio%20host%20portrait%20silver%20hair%20warm%20smile%20professional%20studio%20setting%20authoritative%20dignified%20experienced%20broadcast%20veteran&width=200&height=200&seq=pm-alejandro&orientation=squarish',
        type: 'locutor',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 6 horas',
      },
      {
        id: 'pm-user-ana',
        name: 'Ana Paula Torres',
        username: '@anapaula_oye',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20professional%20elegant%20style%20warm%20smile%20pearl%20earrings%20soft%20studio%20lighting%20editorial%20portrait%20refined%20sophisticated%20approachable&width=200&height=200&seq=pm-ana&orientation=squarish',
        type: 'oyente',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
    ],
    lastMessage: 'Muchas gracias don Alejandro. Sus consejos valen oro. Le mando la grabación apenas la termine.',
    lastMessageTime: '2026-06-20T18:00:00Z',
    lastMessageRelative: 'Ayer',
    unreadCount: 0,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-6-1',
        conversationId: 'conv-6',
        senderId: 'pm-user-ana',
        senderName: 'Ana Paula Torres',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20professional%20elegant%20style%20warm%20smile%20pearl%20earrings%20soft%20studio%20lighting%20editorial%20portrait%20refined%20sophisticated%20approachable&width=80&height=80&seq=pm-msg-6-1&orientation=squarish',
        text: 'Don Alejandro, buenas tardes. Soy Ana Paula, estudiante de periodismo. La escucho desde que tengo memoria y quería pedirle un consejo.',
        timestamp: '2026-06-20T17:00:00Z',
        timestampRelative: 'Ayer 17:00',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-6-2',
        conversationId: 'conv-6',
        senderId: 'pm-user-alejandro',
        senderName: 'Alejandro Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Mature%20distinguished%20Latino%20radio%20host%20portrait%20silver%20hair%20warm%20smile%20professional%20studio%20setting%20authoritative%20dignified%20experienced%20broadcast%20veteran&width=80&height=80&seq=pm-msg-6-2&orientation=squarish',
        text: 'Ana Paula, qué gusto recibir tu mensaje. Claro que sí, adelante. Para eso estamos los que tenemos algunos añitos en esto. ¿En qué puedo ayudarte?',
        timestamp: '2026-06-20T17:30:00Z',
        timestampRelative: 'Ayer 17:30',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-6-3',
        conversationId: 'conv-6',
        senderId: 'pm-user-ana',
        senderName: 'Ana Paula Torres',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20professional%20elegant%20style%20warm%20smile%20pearl%20earrings%20soft%20studio%20lighting%20editorial%20portrait%20refined%20sophisticated%20approachable&width=80&height=80&seq=pm-msg-6-3&orientation=squarish',
        text: 'Estoy preparando mi primer demo de programa de radio. Un magacín cultural con entrevistas. ¿Qué consejo me daría para conectar con la audiencia desde el primer minuto?',
        timestamp: '2026-06-20T17:40:00Z',
        timestampRelative: 'Ayer 17:40',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-6-4',
        conversationId: 'conv-6',
        senderId: 'pm-user-alejandro',
        senderName: 'Alejandro Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Mature%20distinguished%20Latino%20radio%20host%20portrait%20silver%20hair%20warm%20smile%20professional%20studio%20setting%20authoritative%20dignified%20experienced%20broadcast%20veteran&width=80&height=80&seq=pm-msg-6-4&orientation=squarish',
        text: 'Mirá, en 20 años aprendí una cosa: la radio no se trata de vos, se trata de quien te escucha. Hablale a UNA persona, no a miles. Imaginá que estás tomando café con un amigo. Sé auténtica, no un personaje. Y nunca subestimes el poder del silencio — a veces lo que no decís dice más.',
        timestamp: '2026-06-20T17:50:00Z',
        timestampRelative: 'Ayer 17:50',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-6-5',
        conversationId: 'conv-6',
        senderId: 'pm-user-alejandro',
        senderName: 'Alejandro Ramírez',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Mature%20distinguished%20Latino%20radio%20host%20portrait%20silver%20hair%20warm%20smile%20professional%20studio%20setting%20authoritative%20dignified%20experienced%20broadcast%20veteran&width=80&height=80&seq=pm-msg-6-5&orientation=squarish',
        text: 'También te comparto este audio de una charla que di el año pasado sobre el arte de la entrevista radial. Te puede servir.',
        timestamp: '2026-06-20T17:55:00Z',
        timestampRelative: 'Ayer 17:55',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'audio',
          url: '',
          name: 'charla_arte_entrevista.mp3',
          duration: '12:20',
          size: '17.8 MB',
        },
      },
      {
        id: 'msg-6-6',
        conversationId: 'conv-6',
        senderId: 'pm-user-ana',
        senderName: 'Ana Paula Torres',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20woman%20professional%20elegant%20style%20warm%20smile%20pearl%20earrings%20soft%20studio%20lighting%20editorial%20portrait%20refined%20sophisticated%20approachable&width=80&height=80&seq=pm-msg-6-6&orientation=squarish',
        text: 'Muchas gracias don Alejandro. Sus consejos valen oro. Le mando la grabación apenas la termine.',
        timestamp: '2026-06-20T18:00:00Z',
        timestampRelative: 'Ayer 18:00',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 7: Oyente ↔ Moderador ═══════
  {
    id: 'conv-7',
    type: 'oyente-moderador',
    participants: [
      {
        id: 'pm-user-felipe',
        name: 'Felipe El Podcaster',
        username: '@felipe_podcast',
        photoUrl: 'https://readdy.ai/api/search-image?query=Latino%20man%20late%20twenties%20podcast%20creator%20style%20casual%20trendy%20headphones%20around%20neck%20modern%20studio%20background%20warm%20lighting%20editorial%20portrait%20creative&width=200&height=200&seq=pm-felipe&orientation=squarish',
        type: 'oyente',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 2 horas',
      },
      {
        id: 'pm-user-pedro',
        name: 'Pedro El Guardián Díaz',
        username: '@pedro_guardian',
        photoUrl: 'https://readdy.ai/api/search-image?query=Latino%20man%20forties%20strong%20but%20kind%20expression%20security%20professional%20style%20clean%20portrait%20authoritative%20warm%20natural%20lighting&width=200&height=200&seq=pm-pedro&orientation=squarish',
        type: 'moderador',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Ahora',
      },
    ],
    lastMessage: 'Así es Felipe. La moderación está para proteger, no para censurar. Buena pregunta.',
    lastMessageTime: '2026-06-19T16:00:00Z',
    lastMessageRelative: 'Hace 2 días',
    unreadCount: 0,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-7-1',
        conversationId: 'conv-7',
        senderId: 'pm-user-felipe',
        senderName: 'Felipe El Podcaster',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20man%20late%20twenties%20podcast%20creator%20style%20casual%20trendy%20headphones%20around%20neck%20modern%20studio%20background%20warm%20lighting%20editorial%20portrait%20creative&width=80&height=80&seq=pm-msg-7-1&orientation=squarish',
        text: 'Pedro, hola. Quería consultarte sobre los límites del contenido en RFW. Estoy preparando un episodio sobre temas polémicos en la radio y quiero asegurarme de no cruzar ninguna línea.',
        timestamp: '2026-06-19T15:00:00Z',
        timestampRelative: 'Hace 2 días',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-7-2',
        conversationId: 'conv-7',
        senderId: 'pm-user-pedro',
        senderName: 'Pedro El Guardián Díaz',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20man%20forties%20strong%20but%20kind%20expression%20security%20professional%20style%20clean%20portrait%20authoritative%20warm%20natural%20lighting&width=80&height=80&seq=pm-msg-7-2&orientation=squarish',
        text: 'Felipe, qué buena iniciativa. La regla es simple: libertad de expresión con responsabilidad. Podés hablar de lo que quieras siempre que no incite al odio, no difame, y respete a todos los miembros de la comunidad. Lo polémico es bienvenido, lo ofensivo no.',
        timestamp: '2026-06-19T15:30:00Z',
        timestampRelative: 'Hace 2 días',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-7-3',
        conversationId: 'conv-7',
        senderId: 'pm-user-felipe',
        senderName: 'Felipe El Podcaster',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20man%20late%20twenties%20podcast%20creator%20style%20casual%20trendy%20headphones%20around%20neck%20modern%20studio%20background%20warm%20lighting%20editorial%20portrait%20creative&width=80&height=80&seq=pm-msg-7-3&orientation=squarish',
        text: 'Entendido. ¿Y hay algún proceso de revisión previa para este tipo de contenido?',
        timestamp: '2026-06-19T15:45:00Z',
        timestampRelative: 'Hace 2 días',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-7-4',
        conversationId: 'conv-7',
        senderId: 'pm-user-pedro',
        senderName: 'Pedro El Guardián Díaz',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20man%20forties%20strong%20but%20kind%20expression%20security%20professional%20style%20clean%20portrait%20authoritative%20warm%20natural%20lighting&width=80&height=80&seq=pm-msg-7-4&orientation=squarish',
        text: 'No para podcasts, confiamos en nuestros creadores. Pero si querés, mandame un resumen antes de publicar y te doy mi opinión. Prefiero prevenir que lamentar.',
        timestamp: '2026-06-19T16:00:00Z',
        timestampRelative: 'Hace 2 días',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-7-5',
        conversationId: 'conv-7',
        senderId: 'pm-user-pedro',
        senderName: 'Pedro El Guardián Díaz',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Latino%20man%20forties%20strong%20but%20kind%20expression%20security%20professional%20style%20clean%20portrait%20authoritative%20warm%20natural%20lighting&width=80&height=80&seq=pm-msg-7-5&orientation=squarish',
        text: 'Así es Felipe. La moderación está para proteger, no para censurar. Buena pregunta.',
        timestamp: '2026-06-19T16:00:00Z',
        timestampRelative: 'Hace 2 días',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
    ],
  },

  // ═══════ CONVERSACIÓN 8: Locutor ↔ Locutor ═══════
  {
    id: 'conv-8',
    type: 'locutor-locutor',
    participants: [
      {
        id: 'pm-user-daniela',
        name: 'Daniela La Voz Urbina',
        username: '@daniela_urbina',
        photoUrl: 'https://readdy.ai/api/search-image?query=Friendly%20Latina%20female%20radio%20host%20bright%20engaging%20smile%20professional%20broadcast%20headset%20modern%20studio%20warm%20lighting%20authentic%20editorial%20portrait&width=200&height=200&seq=pm-daniela&orientation=squarish',
        type: 'locutor',
        isOnline: false,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'Hace 12 horas',
      },
      {
        id: 'pm-user-sofia-dj',
        name: 'Sofía Linares',
        username: '@sofia_dj',
        photoUrl: 'https://readdy.ai/api/search-image?query=Young%20Latina%20radio%20DJ%20portrait%20trendy%20street%20style%20urban%20studio%20with%20neon%20lights%20vibrant%20energetic%20atmosphere%20editorial%20lifestyle%20photography&width=200&height=200&seq=pm-sofia-linares&orientation=squarish',
        type: 'locutor',
        isOnline: true,
        isTyping: false,
        isBlocked: false,
        lastSeen: 'En cabina',
      },
    ],
    lastMessage: '¡Confirmado! ¡Colaboración Venezuela-Colombia en vivo! RFW está cada día más unido. 🇻🇪🤝🇨🇴',
    lastMessageTime: '2026-06-21T06:00:00Z',
    lastMessageRelative: 'Hace 4 horas',
    unreadCount: 2,
    isPinned: false,
    isArchived: false,
    messages: [
      {
        id: 'msg-8-1',
        conversationId: 'conv-8',
        senderId: 'pm-user-daniela',
        senderName: 'Daniela La Voz Urbina',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Friendly%20Latina%20female%20radio%20host%20bright%20engaging%20smile%20professional%20broadcast%20headset%20modern%20studio%20warm%20lighting%20authentic%20editorial%20portrait&width=80&height=80&seq=pm-msg-8-1&orientation=squarish',
        text: '¡Sofi! Hermana latinoamericana. Te escribo porque vi tu set de anoche y ¡qué locura! La energía que manejás es increíble. 🔥',
        timestamp: '2026-06-21T05:00:00Z',
        timestampRelative: 'Hace 5 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-8-2',
        conversationId: 'conv-8',
        senderId: 'pm-user-sofia-dj',
        senderName: 'Sofía Linares',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20radio%20DJ%20portrait%20trendy%20street%20style%20urban%20studio%20with%20neon%20lights%20vibrant%20energetic%20atmosphere%20editorial%20lifestyle%20photography&width=80&height=80&seq=pm-msg-8-2&orientation=squarish',
        text: '¡Dani! Gracias beba 💜 La verdad estaba inspirada. Y hablando de inspiración, ¿cuándo hacemos esa colaboración que venimos hablando? Venezuela + Colombia = ¡explosión!',
        timestamp: '2026-06-21T05:15:00Z',
        timestampRelative: 'Hace 5 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-8-3',
        conversationId: 'conv-8',
        senderId: 'pm-user-daniela',
        senderName: 'Daniela La Voz Urbina',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Friendly%20Latina%20female%20radio%20host%20bright%20engaging%20smile%20professional%20broadcast%20headset%20modern%20studio%20warm%20lighting%20authentic%20editorial%20portrait&width=80&height=80&seq=pm-msg-8-3&orientation=squarish',
        text: '¡SIIII! Tengo una idea: un especial de 2 horas donde mezclemos lo mejor del Caribe. Vos desde Medellín, yo desde Caracas. Música, cultura, entrevistas cruzadas. ¿Te animás?',
        timestamp: '2026-06-21T05:30:00Z',
        timestampRelative: 'Hace 4.5 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
        attachment: {
          type: 'imagen',
          url: 'https://readdy.ai/api/search-image?query=Colorful%20vibrant%20Caribbean%20music%20festival%20poster%20design%20with%20tropical%20elements%20palm%20trees%20musical%20instruments%20warm%20sunset%20colors%20festive%20celebration%20atmosphere%20editorial%20design&width=800&height=500&seq=pm-att-img-3&orientation=landscape',
          name: 'idea_caribe_fest.jpg',
          size: '3.2 MB',
          width: 800,
          height: 500,
        },
      },
      {
        id: 'msg-8-4',
        conversationId: 'conv-8',
        senderId: 'pm-user-sofia-dj',
        senderName: 'Sofía Linares',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Young%20Latina%20radio%20DJ%20portrait%20trendy%20street%20style%20urban%20studio%20with%20neon%20lights%20vibrant%20energetic%20atmosphere%20editorial%20lifestyle%20photography&width=80&height=80&seq=pm-msg-8-4&orientation=squarish',
        text: 'Dani, ¡esto es lo más hermoso que vi! 😭💜 Ese diseño está brutal. Dale, hagámoslo. Coordinemos con las producciones.',
        timestamp: '2026-06-21T05:45:00Z',
        timestampRelative: 'Hace 4 horas',
        isRead: true,
        isDeleted: false,
        isReported: false,
      },
      {
        id: 'msg-8-5',
        conversationId: 'conv-8',
        senderId: 'pm-user-daniela',
        senderName: 'Daniela La Voz Urbina',
        senderPhoto: 'https://readdy.ai/api/search-image?query=Friendly%20Latina%20female%20radio%20host%20bright%20engaging%20smile%20professional%20broadcast%20headset%20modern%20studio%20warm%20lighting%20authentic%20editorial%20portrait&width=80&height=80&seq=pm-msg-8-5&orientation=squarish',
        text: '¡Confirmado! ¡Colaboración Venezuela-Colombia en vivo! RFW está cada día más unido. 🇻🇪🤝🇨🇴',
        timestamp: '2026-06-21T06:00:00Z',
        timestampRelative: 'Hace 4 horas',
        isRead: false,
        isDeleted: false,
        isReported: false,
      },
    ],
  },
];

export const conversationTypeLabels: Record<ConversationType, string> = {
  'oyente-oyente': 'Oyente ↔ Oyente',
  'oyente-locutor': 'Oyente ↔ Locutor',
  'oyente-moderador': 'Oyente ↔ Moderador',
  'locutor-locutor': 'Locutor ↔ Locutor',
};

export const conversationTypeIcons: Record<ConversationType, string> = {
  'oyente-oyente': 'ri-user-smile-line',
  'oyente-locutor': 'ri-mic-line',
  'oyente-moderador': 'ri-shield-check-line',
  'locutor-locutor': 'ri-user-voice-line',
};

export const conversationTypeColors: Record<ConversationType, { badge: string; ring: string; icon: string }> = {
  'oyente-oyente': { badge: 'bg-emerald-100 text-emerald-700 border-emerald-200', ring: 'ring-emerald-400', icon: 'text-emerald-600' },
  'oyente-locutor': { badge: 'bg-amber-100 text-amber-700 border-amber-200', ring: 'ring-amber-400', icon: 'text-amber-600' },
  'oyente-moderador': { badge: 'bg-rose-100 text-rose-700 border-rose-200', ring: 'ring-rose-400', icon: 'text-rose-600' },
  'locutor-locutor': { badge: 'bg-violet-100 text-violet-700 border-violet-200', ring: 'ring-violet-400', icon: 'text-violet-600' },
};

export const attachmentTypeConfig: Record<MessageAttachmentType, { label: string; icon: string; color: string; bgColor: string }> = {
  imagen: { label: 'Imagen', icon: 'ri-image-line', color: 'text-sky-600', bgColor: 'bg-sky-50' },
  audio: { label: 'Audio', icon: 'ri-mic-line', color: 'text-rose-600', bgColor: 'bg-rose-50' },
  sticker: { label: 'Sticker', icon: 'ri-emotion-laugh-line', color: 'text-amber-600', bgColor: 'bg-amber-50' },
  gif: { label: 'GIF', icon: 'ri-file-gif-line', color: 'text-violet-600', bgColor: 'bg-violet-50' },
};

export const privateMessagesRules = [
  {
    id: 1,
    title: 'Respetá a tu interlocutor',
    description: 'Los mensajes privados son un espacio de confianza. Tratá a los demás como te gustaría que te traten. El respeto es la base de toda conversación.',
    icon: 'ri-heart-line',
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
  },
  {
    id: 2,
    title: 'No uses MD para lo que es de Cabina',
    description: 'Saludos, peticiones de canciones y mensajes al aire van por la Cabina, NO por mensajes privados. La magia de la radio está en compartir en vivo.',
    icon: 'ri-broadcast-line',
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
  },
  {
    id: 3,
    title: 'Reportá, no confrontes',
    description: 'Si alguien te molesta, bloquealo y reportalo. No entres en discusiones. El equipo de moderación se encarga del resto.',
    icon: 'ri-alert-line',
    color: 'text-red-600',
    bgColor: 'bg-red-50',
  },
];

export function getConversationById(id: string): PrivateConversation | undefined {
  return privateConversations.find((c) => c.id === id);
}

export function getConversationsByType(type: ConversationType | 'todas'): PrivateConversation[] {
  if (type === 'todas') return privateConversations;
  return privateConversations.filter((c) => c.type === type);
}

export function getUnreadCountTotal(): number {
  return privateConversations.reduce((sum, c) => sum + c.unreadCount, 0);
}

export function getPinnedConversations(): PrivateConversation[] {
  return privateConversations.filter((c) => c.isPinned);
}

export function getOnlineContacts(): ConversationParticipant[] {
  const participants: ConversationParticipant[] = [];
  privateConversations.forEach((c) => {
    c.participants.forEach((p) => {
      if (p.isOnline && !participants.find((x) => x.id === p.id)) {
        participants.push(p);
      }
    });
  });
  return participants;
}